import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { ResourceSummary } from "../../ResourceSummary";
import { SuperDashboardCard } from "../../SuperDashboard";
import React from 'react';
export var ResourceProportionStatistics = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    ref: ref
  }, properties, {
    title: false,
    bodyStyle: _objectSpread({
      paddingBlock: 8
    }, properties.bodyStyle)
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: 'rgba(0, 0, 0, 0.88)',
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '1.5714285714285714'
    }
  }, properties.title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ResourceSummary, {
    colorField: "key",
    angleField: "value",
    datum: properties.datum
  }))), properties.children);
});
ResourceProportionStatistics.isProCard = true;